import _ from 'lodash';
import { callApi } from 'src/core/callApi';
import { convertCurrency } from 'src/utils/functions';

export const triggerMarketCache = (targetMarketName, comparisons) => {
  try {
    const targetMarketInfo = comparisons.filter(market => market.label === targetMarketName)[0]
      .details;
    const url = 'https://68gjq7no20.execute-api.us-east-2.amazonaws.com/default/getDistrictInfo';

    const config = {
      district: targetMarketInfo['name'],
      city: targetMarketInfo['city'],
      country: targetMarketInfo['country'],
    };
    callApi(url, { queryParams: config }, true);
  } catch (err) {
    console.error('Error while triggering market cache: ', err);
  }
};

export const processMarketData = (data, selectedBedroom, currency, comparisons) => {
  const marketDataRow: any[] = [];

  const anyBedroomFilterSelected = selectedBedroom === 'any';

  let index: number = 0;
  for (const market in data) {
    const marketData: any = data[market]['message'];
    const isCacheOutdated = marketData['is_cache_outdated'];

    isCacheOutdated && triggerMarketCache(market, comparisons);

    marketDataRow.push(
      isCacheOutdated
        ? {
            id: index++,
            name: market,
            occupancy: '',
            adr: '',
            revenue: '',
            listings: '',
            isCacheOutdated: true,
          }
        : anyBedroomFilterSelected
        ? {
            id: index++,
            name: market,
            occupancy: marketData?.ltm_performance?.occupancy_rate,
            adr: convertCurrency(currency, marketData?.ltm_performance?.adr),
            revenue: convertCurrency(currency, marketData?.ltm_performance?.revenue),
            listings: marketData?.ltm_performance?.supply,
          }
        : {
            id: index++,
            name: market,
            occupancy: marketData?.occupancy_breakdown?.bedroom[selectedBedroom],
            adr: convertCurrency(currency, marketData?.adr_breakdown?.bedroom[selectedBedroom]),
            revenue: convertCurrency(
              currency,
              marketData?.revenue_breakdown?.bedroom[selectedBedroom]
            ),
            listings: marketData?.supply_breakdown?.bedroom[selectedBedroom],
          }
    );
  }

  return marketDataRow;
};

export const processReportData = (data: any, currency: string) => {
  const marketDataRow: any[] = [];

  let index: number = 0;
  for (const reportId in data) {
    const report: any = data[reportId];
    if (!report) return marketDataRow;

    const reportKpi = report['kpi']['50'];
    const occupancyRate = reportKpi['ltm_occupancy_rate'];
    const revenue = reportKpi['ltm_revenue'];
    const adr = reportKpi['ltm_nightly_rate'];

    const address = report['primary_input']['address_short'];
    const bedrooms = report['primary_input']['bedrooms'];
    const reportType = _.capitalize(report['primary_input']['report_type']);

    marketDataRow.push({
      id: index++,
      name: address,
      bedrooms: bedrooms,
      reportType: reportType,
      occupancy: occupancyRate,
      adr: convertCurrency(currency, adr),
      revenue: convertCurrency(currency, revenue),
      currency: currency,
    });
  }

  return marketDataRow;
};

export const generateDownloadFilename = () => {
  const date = new Date();
  //  YYYYMMDD_HHMMSS
  const dateTime = date
    .toISOString()
    .replace(/[-:T]/g, '')
    .split('.')[0];
  // Generate a random 8 digit string
  const randomString = Math.random()
    .toString(36)
    .substring(2, 10)
    .toLowerCase();
  return `market_compare_${dateTime}_${randomString}.csv`;
};

export const processArrayToCsv = (data: { [key: string]: number | string }[], addHeader = true) => {
  if (!data.length) return '';

  const escapeCSVValue = (value: number | string) => {
    const str = String(value).replace(/"/g, '""');
    return str.includes(',') ? `"${str}"` : str;
  };

  let csv = data.map(row =>
    Object.values(row)
      .map(escapeCSVValue)
      .join(',')
  );

  if (addHeader) {
    const header = Object.keys(data[0]);
    csv.unshift(header.map(escapeCSVValue).join(','));
  }

  return csv.join('\n');
};

export const getSavedReports = async setData => {
  const url =
    'https://3iugob4wql.execute-api.us-east-2.amazonaws.com/prod/airbnbCalculatorReportCRUD';
  const data = await callApi(url, {}, true, false, '', 'GET', true);
  if (data && !data.error && data.reports) {
    setData(data.reports);
  }
};
